import { render } from "./ErrorPageNoToken.vue?vue&type=template&id=4f608e7a&scoped=true"
import script from "./ErrorPageNoToken.vue?vue&type=script&lang=js"
export * from "./ErrorPageNoToken.vue?vue&type=script&lang=js"

import "./ErrorPageNoToken.vue?vue&type=style&index=0&id=4f608e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f608e7a"]])

export default __exports__